import { render, staticRenderFns } from "./SessionEnded.vue?vue&type=template&id=072f608f&"
import script from "./SessionEnded.vue?vue&type=script&lang=ts&"
export * from "./SessionEnded.vue?vue&type=script&lang=ts&"
import style0 from "./SessionEnded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports